import React from 'react';

// Grey placeholders shown while something loads, instead of the bare word "Loading..." (styles: index.css, .sk).

/** `n` lines of different lengths, as a stand-in for a block of text or a short list. */
export function SkeletonLines({ n = 3, label = 'Loading' }) {
  const widths = ['100%', '82%', '64%', '90%', '48%'];
  return (
    <div className="sk-lines" role="status" aria-busy="true" aria-label={label}>
      {Array.from({ length: n }, (_, i) => <span key={i} className="sk sk-line" style={{ width: widths[i % widths.length] }} />)}
    </div>
  );
}

/** A page-sized placeholder: a heading bar and a few card-like blocks. */
export function SkeletonPage() {
  return (
    <div className="sk-page" role="status" aria-busy="true" aria-label="Loading">
      <span className="sk sk-title" />
      <span className="sk sk-block" />
      <span className="sk sk-block" />
    </div>
  );
}

/** Placeholder table rows for DataTable: one grey bar per column. */
export function SkeletonRows({ columns, rows = 5 }) {
  return Array.from({ length: rows }, (_, r) => (
    <tr key={r} className="sk-row" aria-hidden="true">
      {columns.map((c, i) => (
        <td key={c.key} data-label={c.label} className={c.align === 'right' ? 'adm-right' : ''}>
          <span className="sk sk-line" style={{ width: i === 0 ? '70%' : `${45 + ((r + i) % 3) * 15}%`, marginLeft: c.align === 'right' ? 'auto' : undefined }} />
        </td>
      ))}
    </tr>
  ));
}
